import { memo } from 'react';

import { StaticRectangle } from '../../../../components/rectangle';
import { MultiStorePanelContent } from './multi-store-panel-content';

interface MultiStorePanelProps {
  id: string;
}

// Pannello «In quali centri vuoi cercare?», sotto la riga d'ingresso o di riepilogo.
// Nessun hook qui: StaticRectangle rimonta i figli a ogni render (key nanoid), quindi la
// bozza vive nel contenuto e questo involucro, con una sola prop stabile, non si ridisegna
// finché il pannello resta aperto.
export const MultiStorePanel = memo(function MultiStorePanel({
  id,
}: MultiStorePanelProps): JSX.Element {
  return (
    <div id={id}>
      <StaticRectangle>
        <MultiStorePanelContent />
      </StaticRectangle>
    </div>
  );
});
